import { productCardStyles as styles } from "@iewccouk/Overrides/Widgets/ProductList/ProductListProductCard";
import { colorStrings, mediaQueriesBP } from "@iewccouk/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.gridContainer = {
    ...styles.gridContainer,
    css: css`
        display: flex;
        gap: 10px;
        width: 100%;
        padding: 30px 0;

        ${mediaQueriesBP.minMD} {
            &[data-card-selector="product-card--table"] {
                padding: 20px;
            }
        }
    `,
    offsetCss: css`
        ${mediaQueriesBP.minMD} {
            &[data-card-selector="product-card--table"] {
                justify-content: space-between;
                flex-wrap: nowrap !important;
            }
        }
    `,
};

styles.leftColumnGridItem = {
    ...styles.leftColumnGridItem,
    css: css`
        ${mediaQueriesBP.minMD} {
            &[data-test-selector="product-card--table"] {
                flex: 1 1 15%;
                max-width: 15%;
                padding: 0;
            }
        }
    `,
};

styles.rightColumnGridItem = {
    ...styles.rightColumnGridItem,
    css: css`
        ${mediaQueriesBP.minMD} {
            &[data-test-selector="product-card--table"] {
                flex: 2 1 85%;
                max-width: 90%;
            }
        }
    `,
};

styles.rightColumnGridContainer = {
    ...styles.rightColumnGridContainer,

    gap: 0,
    css: css`
        width: 100%;
    `,
    offsetCss: css`
        width: 100%;
        gap: 10px;
        justify-content: space-between;

        ${mediaQueriesBP.minMD} {
            flex-wrap: nowrap !important;
        }
    `,
};

styles.actionsGridItem = {
    // ...styles.actionsGridItem,
    css: css`
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: flex-start;
        width: 100%;
        flex-basis: 100%;
        max-width: 300px;
    `,
};

styles.productListProductImageStyles = {
    ...styles.productListProductImageStyles,

    wrapper: {
        ...styles.productListProductImageStyles?.wrapper,
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: center;
            align-items: center;
        `,
    },

    productImage: {
        linkWrappingImage: {
            css: css`
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                max-height: 190px;
                max-width: 190px;
                padding: 10px;

                img {
                    border: 1px solid ${getColor(colorStrings.commonBorder)};
                    aspect-ratio: 1/1;
                }
            `,
        },
    },
};

styles.minOrderAndMultiplesOf = {
    wrapper: {
        css: css`
            margin-bottom: 0;
        `,
    },
    message: {
        color: colorStrings.textMain,
        forwardAs: "span",
        variant: "legend",
    },
};
